import React from 'react';

const CompaniesFilter = ({locations, typeOfFinancing, selectedLocation, selectedTypeOfFinancing,  updateDropdown, searchText, onSubmit}) => (
    <div className="elementor-text-editor elementor-clearfix" style={{textAlign: 'center'}}>
        <form className="searchandfilter" onSubmit={onSubmit}>
            <ul>
                <li>
                    <input type="text" name="searchText" value={searchText} onChange={updateDropdown} placeholder="Search..."/>
                </li>
                <li>
                    <select name="selectedLocation" value={selectedLocation} onChange={updateDropdown}>
                        <option>All Locations</option>
                        {
                            locations.map((location, idx) => (
                                <option key={idx} value={location.id}>{location.name}</option>
                            ))
                        } 
                    </select>
                </li>
                <li>
                    <select name="selectedTypeOfFinancing" value={selectedTypeOfFinancing} onChange={updateDropdown}>
                        <option>All Type of Financing</option>
                        {
                            typeOfFinancing.map((finance, idx) => (
                                <option key={idx} value={finance.id}>{finance.name}</option>
                            ))
                        } 
                    </select>
                </li>
                {/* <li>
                    <input type="submit" value="Submit" />
                </li> */}
            </ul>
        </form>
    </div>
);

export default CompaniesFilter;